import {useUser} from "../../../features/user/hooks";
import StoryblokLink from "../../link/StoryblokLink";
import ThemeToggle from "../../themeToggle/themeToggle";
import {AccountMenuActionBarButton} from "../accountMenu/accountMenu";

import {CrownSVG} from "../../../svg";

import styles from "./actionBar.module.scss";
import {getUpsellRedirectUrl} from "../../../helpers/upsellHelpers";
import {FormattedMessage} from "react-intl";

function ActionBar({back_to_main_message, back_to_main_link}) {
  const user = useUser();

  return (
    <div className={styles.actionbar}>
      <div className="view with-padding">
        <div className="page-content">
          <div className={styles.actions}>
            <div>
              <StoryblokLink
                className={styles.mainlink}
                linkObject={back_to_main_link}
              >
                {back_to_main_message}
              </StoryblokLink>
            </div>
            <div className={styles.rightactions}>
              {!user?.isPremium && (
                <a
                  className={styles.premiumLink}
                  href={getUpsellRedirectUrl("newweb_organic_header_news")}
                >
                  <CrownSVG />
                  <span>
                    {!user || user.isEligible ? (
                      <FormattedMessage id="watch.upsell_banner.try_premium_free" />
                    ) : (
                      <FormattedMessage id="watch.upsell_banner.go_premium" />
                    )}
                  </span>
                </a>
              )}
              <ThemeToggle />
              <AccountMenuActionBarButton />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export {ActionBar};
